import { GroupIcon } from '../../icons';
import type { TEventStats } from '../../types/event';
import { StatCard } from '../common/StatCard';
import { LoaderSpinner } from '../Loader';

export const EventStatusMetrics = ({
  data,
  isLoading,
}: {
  data: TEventStats;
  isLoading: boolean;
}) => {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4 md:gap-6 my-6">
      {isLoading ? (
        <div className="flex justify-center p-5">
          <LoaderSpinner />
        </div>
      ) : (
        <>
          <StatCard
            title="Joining"
            stat={data?.yes}
            icon={
              <GroupIcon className="text-gray-800 size-6 dark:text-white/90" />
            }
          />
          <StatCard
            title="Not Joining"
            stat={data?.no}
            icon={
              <GroupIcon className="text-gray-800 size-6 dark:text-white/90" />
            }
          />
          <StatCard
            title="Maybe Joining"
            stat={data?.maybe}
            icon={
              <GroupIcon className="text-gray-800 size-6 dark:text-white/90" />
            }
          />
        </>
      )}
    </div>
  );
};
